// This gets replaced by CDK + Webpack at build time
const STAGE = 'beta'; // injected during CDK deploy

export const getStage = () => STAGE;
